import {getPDFLastEnregistrement} from "../server/services/enregistrement-service";
import {connect} from "react-redux";
import jwtDecode from "jwt-decode";
import React, {useEffect, useState} from "react";
import * as navigation from "../constants/navigation-constants";
import withNavigation from "./higher-order/navigation";

const base64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

const ImprimerDernierEnregistrement = (props) => {
    const [pdfBase64Url, setPDFBase64Url] = useState(null);
    useEffect(() => {
        getPDFLastEnregistrement(props?.idProfile, props.language).then(response => {
            if (response.ok)
                return response.json();
            return null
        }).then(response => {
            if (response)
                setPDFBase64Url(URL.createObjectURL(base64toBlob(response, "application/pdf")));
        });
        return () => URL.revokeObjectURL(pdfBase64Url);
    }, [props?.idProfile])

    return (
        props.idProfile == null ?
            <div id="droit-acces-page" className="droit-acces-page">
                <div className="droit-acces-div" style={ {textAlign: "center"} }>
                    <span className="droit-acces-span message">Vous n'êtes pas connecté à votre compte.</span>
                </div>
                <div className="droit-acces-div" style={ {textAlign: "center"} }>
                    <span className="droit-acces-span message">Cliquez ici pour vous </span>
                    <span className="clickable message primary-color droit-acces-span droit-acces-span-primary" onClick={ e => props.gotoProfile(navigation.PATH_REIMPRIME_FICHE_ENREGISTREMENT) }>connecter à votre compte</span>
                    <span className="droit-acces-span message"> ou pour </span>

                </div>
            </div>
            :
            <div style={ {height: "100%", textAlign: "center"} }>
                { pdfBase64Url ? <embed title={ "Fiche d'enregistrement" } src={ pdfBase64Url } width="60%" height="1152"/> : <h1>Vous n'avez aucun enregistrement à réimprimer</h1> }
            </div>

    );
}

function mapStateToProps(state, ownProps) {
    return {
        idProfile: state.authToken ? jwtDecode(state?.authToken)?.idProfile : undefined
    }
}

export default withNavigation(connect(mapStateToProps)(ImprimerDernierEnregistrement));